<template>
  <div class="queue queue_red">
    <div class="queue__wrapper">
      <div class="queue__item">
        <div class="queue__text queue__text_big">
          МТС
        </div>
      </div>
      <div class="queue__item">
        <div class="queue__text">
          {{ $t('success.title') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Success'
}
</script>
